import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { CONTACT, SOLUTIONS } from "../data/content";

export default function Footer() {
  return (
    <footer className="relative border-t border-slate-800/80 bg-[#0A1A33] overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center bg-white rounded-lg px-3 py-2">
                <img src="/logo.png" alt="SATI Global Systems logo" className="h-9 w-auto object-contain" data-testid="footer-logo" />
              </span>
              <span className="font-heading font-bold text-slate-100">SATI GLOBAL SYSTEMS</span>
            </div>
            <p className="text-[10px] font-mono tracking-[0.18em] text-cyan-400/90 mb-3 uppercase">MSME Registered · GeM Authorized Supplier</p>
            <p className="text-sm text-slate-500 leading-relaxed">
              Integrated IT, surveillance, networking, software and project-management solutions for the modern enterprise — engineered in Patna since 2014.
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-400 mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              {[["About Us", "/about"], ["Projects", "/projects"], ["Industries", "/industries"], ["Technology", "/technology"], ["Careers", "/careers"], ["Contact", "/contact"]].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-slate-400 hover:text-cyan-400 transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-400 mb-4">Solutions</h4>
            <ul className="space-y-2.5 text-sm">
              {SOLUTIONS.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link to={`/solutions/${s.slug}`} data-testid={`footer-solution-${s.slug}`}
                    className="text-slate-400 hover:text-cyan-400 transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-400 mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex gap-2.5"><MapPin size={15} className="text-cyan-500 shrink-0 mt-0.5" /><span>{CONTACT.address}</span></li>
              <li className="flex gap-2.5"><Phone size={15} className="text-cyan-500 shrink-0 mt-0.5" />
                <span>{CONTACT.phones.map((p) => (
                  <a key={p} href={`tel:${p.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="block hover:text-cyan-400 transition-colors">{p}</a>
                ))}</span>
              </li>
              <li className="flex gap-2.5"><Mail size={15} className="text-cyan-500 shrink-0 mt-0.5" />
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-cyan-400 transition-colors">{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-slate-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-600">© {new Date().getFullYear()} SATI GLOBAL SYSTEMS. All rights reserved.</p>
          <div className="flex gap-6 text-xs text-slate-600">
            <a href="/SGS-Company-Profile-2026.pdf" download data-testid="footer-download-profile" className="hover:text-cyan-400 transition-colors">Company Profile (PDF)</a>
            <span data-testid="footer-privacy" className="hover:text-slate-400 cursor-pointer transition-colors">Privacy Policy</span>
            <span data-testid="footer-terms" className="hover:text-slate-400 cursor-pointer transition-colors">Terms & Conditions</span>
          </div>
        </div>
      </div>
      <div className="pointer-events-none select-none absolute -bottom-10 left-1/2 -translate-x-1/2 font-heading font-black text-[18vw] leading-none text-outline opacity-[0.06] whitespace-nowrap">
        SATI GLOBAL
      </div>
    </footer>
  );
}
